<template>
  <v-dialog v-model="dialog" max-width="640px" persistent scrollable>
    <v-card>
      <v-card-title>
        <div class="title--text">Đăng ký</div>
        <v-spacer />
        <v-icon class="mr-n1" @click="cancel()">mdi-close</v-icon>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pt-4 pb-2">
        <v-form ref="form">
          <div class="text-subtitle-1 font-weight-medium mb-4">TÀI KHOẢN ĐĂNG KÝ TUYỂN SINH KHỐI {{ signUpGrade }}</div>

          <div class="mb-4">
            <div class="text-subtitle-1">Họ và tên học sinh <span class="required-mark">*</span></div>
            <v-text-field
              v-model="studentName"
              placeholder="VD: Nguyễn Văn A"
              hint="Gõ tiếng Việt có dấu, đúng quy tắc viết hoa"
              persistent-hint
              :rules="[$rules.required, $rules.vietnameseName]"
              outlined
            />
          </div>

          <div class="text-subtitle-1">Ngày tháng năm sinh <span class="required-mark">*</span></div>
          <div class="mb-8">
            <DobSplitTextInput v-model="dob" ref="date-picker" />
          </div>

          <div class="text-subtitle-1">
            Địa chỉ thường trú (Số nhà, Đường/Phố, Xã/Phường, Thành phố)
            <span class="required-mark">*</span>
          </div>
          <v-text-field
            v-model="address"
            placeholder="VD: Số 56 Nguyễn Thị Định, phường Yên Hòa, thành phố Hà Nội"
            :rules="[$rules.required]"
            outlined
          />

          <!-- <div class="text-subtitle-1">
            Nguyện vọng 1 trường cấp 1 <span class="required-mark">*</span>
            <span class="expected-note">(Dự kiến)</span>
          </div>
          <v-autocomplete
            v-model="expectSchool"
            :items="[...elementarySchoolOptions, {name: otherText, value: 'other'}]"
            item-text="name"
            item-value="name"
            :menu-props="{maxHeight: 120}"
            placeholder="Bắt đầu gõ để tìm kiếm..."
            no-data-text="Không tìm thấy trường phù hợp"
            :rules="[$rules.required]"
            :return-object="false"
            autocomplete="on"
            outlined
            clearable
          />
          <v-text-field
            v-if="expectSchool === otherText"
            v-model="otherExpectSchool"
            placeholder="Nhập tên trường tại đây"
            :rules="[$rules.required]"
            outlined
          /> -->

          <div class="mb-4">
            <div class="text-subtitle-1">Họ tên phụ huynh <span class="required-mark">*</span></div>
            <v-text-field
              v-model="parentName"
              placeholder="Nhập tên phụ huynh tại đây"
              hint="Gõ tiếng Việt có dấu, đúng quy tắc viết hoa"
              persistent-hint
              :rules="[$rules.required, $rules.vietnameseName]"
              outlined
            />
          </div>

          <div class="text-subtitle-1">
            Số điện thoại PH (dùng để đăng nhập) <span class="required-mark">*</span>
          </div>
          <v-text-field
            v-model="phone"
            v-mask="'##########'"
            type="tel"
            placeholder="Nhập số điện thoại tại đây (Ví dụ: 097372xxxx)"
            :rules="phoneRules"
            outlined
            validate-on-blur
          />

          <div class="text-subtitle-1">Email liên hệ <span class="required-mark">*</span></div>
          <v-text-field
            v-model="parentEmail"
            placeholder="VD: abcxyz@gmail.com"
            :rules="[$rules.required, $rules.email]"
            outlined
          />

          <v-divider></v-divider>
          <div class="text-subtitle-1 mt-5">Mật khẩu <span class="required-mark">*</span></div>
          <v-text-field
            v-model="password"
            placeholder="PH tự tạo mật khẩu"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            :type="showPassword ? 'text' : 'password'"
            :rules="passwordRules"
            @click:append="showPassword = !showPassword"
            outlined
            validate-on-blur
          />

          <div class="text-subtitle-1">Mật khẩu (nhắc lại) <span class="required-mark">*</span></div>
          <v-text-field
            v-model="confirmPassword"
            placeholder="Nhập lại mật khẩu tại đây"
            :append-icon="showConfirmPassword ? 'mdi-eye' : 'mdi-eye-off'"
            :type="showConfirmPassword ? 'text' : 'password'"
            :rules="confirmPasswordRules"
            @click:append="showConfirmPassword = !showConfirmPassword"
            outlined
            validate-on-blur
          />
        </v-form>
      </v-card-text>

      <v-divider></v-divider>
      <v-card-actions class="flex-column">
        <v-btn
          depressed
          x-large
          color="primary"
          class="white--text text-subtitle-1 mt-4 text-none full-width"
          :loading="loading"
          @click="submit"
        >
          Đăng ký
        </v-btn>
        <v-btn
          plain
          x-large
          color="primary"
          class="text-subtitle-1 font-weight-bold mt-2 text-none full-width"
          @click="signin"
        >
          Đã có tài khoản? Đăng nhập
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import elementarySchools from '../../assets/ele_school_v2.json'
import utils from '@/plugins/utils'
import DobSplitTextInput from '../../modules/home/update-missing-dialog/DobSplitTextInput.vue'

export default {
  name: 'PrimarySignUpDialog',
  components: {DobSplitTextInput},
  data() {
    return {
      dialog: false,
      loading: false,
      studentName: '',
      dob: '',
      address: '',
      expectSchool: '',
      otherExpectSchool: '',
      parentName: '',
      phone: '',
      parentEmail: '',
      password: '',
      confirmPassword: '',
      showPassword: false,
      showConfirmPassword: false,
      token: '',
      elementarySchoolOptions: elementarySchools,
      otherText: '+ NHẬP TRƯỜNG KHÁC',
      phoneRules: [this.$rules.required, this.$rules.phone],
      passwordRules: [this.$rules.required, this.$rules.minLength(4)],
      confirmPasswordRules: [
        this.$rules.required,
        this.$rules.minLength(4),
        value => (value && value === this.password) || 'Mật khẩu (nhập lại) không trùng khớp với mật khẩu.',
      ],
    }
  },
  computed: {
    ...mapGetters('layout', ['signUpDialog']),
    ...mapGetters('auth', ['isAuthenticated', 'user']),
    ...mapGetters('site', ['siteGrade', 'siteLevel']),
    // Form dùng chung cho mọi khối; khối theo site (localhost chưa xác định site thì giữ Khối 1).
    // BE cũng tự lấy khối theo site, giá trị gửi lên chỉ để tương thích.
    signUpGrade() {
      return this.siteGrade || '1'
    },
  },
  watch: {
    signUpDialog: {
      immediate: true,
      handler(value) {
        this.dialog = value
      },
    },
    dialog: {
      immediate: true,
      handler(value) {
        if (!value) return
        this.token = ''
        this.$nextTick(() => this.renderCF())
      },
    },
  },
  methods: {
    ...mapActions('auth', ['signUp']),
    ...mapActions('lead', ['createLead']),
    ...mapActions('layout', ['setSignUpDialog', 'setSignInDialog', 'setConfirmSignupDialog']),
    cancel() {
      this.$refs.form.reset()
      this.setSignUpDialog(false)
    },
    signin() {
      this.setSignUpDialog(false)
      this.setSignInDialog(true)
    },
    async submit() {
      const {isValid: isDobValid} = this.$refs['date-picker'].validate()
      if (!isDobValid) return this.$alert.error('Vui lòng nhập ngày sinh chuẩn')
      if (!this.$refs.form.validate()) {
        this.scrollToFirstError()
        return
      }

      const finalExpectation =
        this.expectSchool === this.otherText ? `(Khác) ${this.otherExpectSchool}` : this.expectSchool

      const emailData = {
        parentEmail: this.parentEmail,
        parentName: this.parentName,
        studentName: this.studentName,
        dob: this.formatDob(this.dob),
        parentPhone: this.phone,
      }
      const userStudentData = {
        name: this.studentName,
        dob: this.formatDob(this.dob),
        expectSchool: finalExpectation,
        address: this.address,
      }
      const leadData = {
        phone: this.phone,
        buyerName: this.parentName,
        email: this.parentEmail,
        createdByName: 'parent',
        expectSchool: finalExpectation,
        studentExpectSchoolSearchField: utils.removeUnicode(finalExpectation).toLowerCase(),
        studentNameSearchField: utils.removeUnicode(this.studentName).toLowerCase(),
        type: ['hasAccount', 'noCV'],
        data: {
          student: [
            {
              name: this.studentName,
              dob: this.formatDob(this.dob),
              address: this.address,
            },
          ],
        },
      }

      try {
        this.loading = true
        const user = await this.signUp({
          username: this.phone,
          password: this.password,
          phone: this.phone,
          email: this.parentEmail,
          name: this.parentName,
          userStudentData,
          cfToken: this.token,
          enrollmentGrade: this.siteLevel || 'primary',
          emailData,
        })
        if (user) await this.createLead(leadData)

        if (this.user && this.isAuthenticated) {
          this.$refs.form.reset()
          this.setSignUpDialog(false)
          this.setConfirmSignupDialog(true)
        } else {
          this.resetTurnstile()
        }
      } catch (error) {
        if (error === 'Email already taken' || error === 'Email is already taken.') {
          console.log('[ERROR]: ', error)
          this.$alert.error('Thông tin đã có trong hệ thống. Xin vui lòng kiểm tra lại!', {
            customClass: 'my-unique-alert',
          })
        } else {
          this.$alert.error('Tạo tài khoản thất bại!')
        }
      } finally {
        this.loading = false
      }
    },
    scrollToFirstError() {
      this.$nextTick(() => {
        const dialog = document.querySelector('.v-dialog.v-dialog--active')
        const dialogContent = dialog && dialog.querySelector('.v-card__text')
        const firstErrorInput = dialog && dialog.querySelector('.v-input.error--text')
        if (!dialogContent || !firstErrorInput) return

        const top = firstErrorInput.getBoundingClientRect().top - dialogContent.getBoundingClientRect().top
        dialogContent.scrollTo({
          top: dialogContent.scrollTop + top - 32,
          behavior: 'smooth',
        })
        const input = firstErrorInput.querySelector('input, textarea')
        if (input) input.focus()
      })
    },
    renderCF() {
      const cfContainer = document.querySelector('.cf-turnstile')
      if (cfContainer) cfContainer.innerHTML = ''
      if (!window.turnstile || !cfContainer) return

      window.turnstile.render('.cf-turnstile', {
        sitekey: '0x4AAAAAAAQ-PRt09feV7Bnr',
        theme: 'light',
        callback: token => {
          if (token) this.token = token
        },
      })
    },
    resetTurnstile() {
      const turnstileContainer = document.querySelector('.cf-turnstile')
      if (!turnstileContainer) return
      turnstileContainer.innerHTML = ''
      this.renderCF()
    },
    formatDob(dob) {
      if (!dob) return
      const [day, month, year] = dob.split('/')
      return [year, month, day].join('-')
    },
  },
}
</script>

<style scoped>
.required-mark {
  color: red;
}
.expected-note {
  color: #707070;
  font-size: 12px;
}
.full-width {
  width: 100%;
}
</style>
